module.exports = __webpack_public_path__ + "img/MW_Telegram_Instruction_1.e052fce7.gif";